import type { PublicApiKey } from '#packages/apilib';
import type { createMobileEditorApi } from './mobileEditorWrapper';

export const MobileEditorApiKey: PublicApiKey<typeof createMobileEditorApi> = {
  name: 'MobileEditorApi',
  public: true,
};
